import React, { useState, useEffect } from "react";
import { MDBRow, MDBBtn } from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import Skeleton from "@mui/material/Skeleton";
import axios from "axios";
import InputMask from "react-input-mask";
//
import { validate } from "../components/login/validate";
// config
import configData from "../config/config.json";
// components
import MetaTagsBusinessOwners from "../components/meta-tags-seo/MetaTagsBusinessOwners";
import AlertSuccess from "../components/AlertSuccess/AlertSuccess";
import RegisterBusiness from "./RegisterBusiness";
// img
import imgg from "../images/register-business/04.png";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const RegisterBusinessStep4 = (props) => {
  const formatChar = {
    0: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]",
  };

  const [newSocialMedia, setnewSocialMedia] = useState([
    {},
    {},
    {},
    {},
    {},
    {},
  ]);
  const [activeSocialName, setActiveSocialName] = useState("");

  const [dataCome, setDataCome] = useState(false);
  const [socialCome, setSocialCome] = useState(false);

  const [disable, setDisable] = useState(false);
  const [render, setRender] = useState(false);
  const [phonestd, setPhonestd] = useState("");

  const [businessAddId, setBusinessAddId] = useState(0);

  useEffect(() => {
    if (props.location.state) {
      setPhonestd(props.location.state);
    } else {
      const items = JSON.parse(localStorage.getItem("phonestd"));
      if (items) {
        setPhonestd(items);
      }
    }
  }, []);

  useEffect(() => {
    if (render) {
      localStorage.setItem("phonestd", JSON.stringify(phonestd));
    }
  }, [phonestd]);

  const [data, setData] = useState({
    phonee1: "",
    phonee2: "",
    phonee3: "",
    phonee4: "",
    phonee5: "",
    phonee6: "",
  });

  const [socialM, setsocialM] = useState({
    Youtube: "",
    facebook: "",
    twitter: "",
    instagram: "",
    Telegram: "",
    linkedin: "",
  });

  const [errorPhone1, seterrorPhone1] = useState("");
  const [errorPhone2, seterrorPhone2] = useState("");
  const [errorPhone3, seterrorPhone3] = useState("");
  const [errorPhone4, seterrorPhone4] = useState("");

  const [CompletePhone, setCompletePhone] = useState({});
  const [PhoneApi, setPhoneApi] = useState({
    phonee1: "",
    phonee2: "",
    phonee3: "",
    phonee4: "",
  });
  const inputChangeHandler = (event) => {
    var result;
    if (event.target.name == "phonee5" || event.target.name == "phonee6") {
      var value = event.target.value;
      result = value.replace(/[^A-Za-z\u0030-\u0039\s,@._-]/g, "");
    } else {
      var value = event.target.value;
      result = value.replace(/[^A-Za-z\u0030-\u0039\s,@.]/g, "");
    }

    setData({ ...data, [event.target.name]: result });
    var num = result.replace(/\D/g, "").length;
    // console.log(result.replace(/\D/g, ""));
    // setPhoneApi({
    //   ...PhoneApi,
    //   [event.target.name]: result.replace(/\D/g, ""),
    // });

    if (num >= 10) {
      switch (event.target.name) {
        case "phonee1":
          seterrorPhone1("");
          break;
        case "phonee2":
          seterrorPhone2("");
          break;
        case "phonee3":
          seterrorPhone3("");
          break;
        case "phonee4":
          seterrorPhone4("");
          break;
      }
    } else if (num == 0) {
      switch (event.target.name) {
        case "phonee1":
          seterrorPhone1("");
          break;
        case "phonee2":
          seterrorPhone2("");
          break;
        case "phonee3":
          seterrorPhone3("");
          break;
        case "phonee4":
          seterrorPhone4("");
          break;
      }
    } else {
      switch (event.target.name) {
        case "phonee1":
          seterrorPhone1("شماره تماس را صحیح وارد کنید.");
          break;
        case "phonee2":
          seterrorPhone2("شماره تماس را صحیح وارد کنید.");
          break;
        case "phonee3":
          seterrorPhone3("شماره فکس را صحیح وارد کنید.");
          break;
        case "phonee4":
          seterrorPhone4("شماره موبایل را صحیح وارد کنید.");
          break;
      }
    }
  };
  // validate
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  useEffect(() => {
    setErrors(validate(data, "register-business-s5"));
  }, [data, touched]);

  const [social, setSocial] = useState({
    Youtube: false,
    facebook: false,
    twitter: false,
    instagram: false,
    Telegram: false,
    linkedin: false,
  });

  const socialHandler = (x) => {
    setActiveSocialName(x);
  };

  const [showAlert, setshowAlert] = useState(false);

  const alertHandeler = (event) => {
    event.preventDefault();
    setSocialCome(false);

    for (let index = 0; index < newSocialMedia.length; index++) {
      const element = newSocialMedia[index];
      if (event.target.name == element.title) {
        var add = element.address;
        var smid = element.smId;
      }
    }

    const dataPost2 = {
      bId: getCookie("BizId"),
      smId: smid,
      address: add,
    };

    axios
      .post(
        configData.API_DOMAIN +
          `/api/v1/Businesses/${getCookie("BizUuid")}/socials`,
        dataPost2,
        {
          headers: header,
        }
      )
      .then((response) => {
        setDisable(false);
        if (response.data.isSuccess) {
          // api to get data of social
          axios
            .get(
              configData.API_DOMAIN +
                `/api/v1/Businesses/${getCookie("BizUuid")}/contacts`,
              {
                headers: {
                  ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
                  LangId: 1,
                  Authorization: "Bearer " + getCookie("token"),
                },
              }
            )
            .then((response) => {
              if (response.data.isSuccess) {
                // success
                setshowAlert(true);
                setTimeout(() => {
                  setshowAlert(false);
                }, 2000);

                setnewSocialMedia([]);

                let data = response.data.data;

                setnewSocialMedia(data.socials);
                setSocialCome(true);

                for (let index = 0; index < data.socials.length; index++) {
                  const element = data.socials[index];
                  if (element.address != "") {
                    setActiveSocialName(element.title);
                  }
                }
                if (activeSocialName == "") {
                  setActiveSocialName(data.socials[0].title);
                }
              }
            })
            .catch((error) => {
              // alert(error);
            });
        } else {
          setSocialCome(true);
        }
      })
      .catch((error) => {
        // alert(error);
      });
  };

  const socialMHandeler2 = (event, number) => {
    event.preventDefault();

    const nextArray = newSocialMedia.map((c, i) => {
      if (c.smId === number) {
        var x = {
          smId: c.smId,
          icon: c.icon,
          iconPath: c.iconPath,
          title: c.title,
          address: event.target.value,
          bsaId: c.bsaId,
        };
        return x;
      } else {
        return c;
      }
    });

    setnewSocialMedia(nextArray);
  };

  const [socialMedia, setSocialMedia] = useState([]);

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "register-business-step5",
    Authorization: "Bearer " + getCookie("token"),
  };

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    BizId: getCookie("BizId"),
    Authorization: "Bearer " + getCookie("token"),
  };

  // api
  useEffect(() => {
    setDataCome(false);
    setSocialCome(false);

    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else {
      setnewSocialMedia([{}, {}, {}, {}, {}, {}]);
      // api for meta tags
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // api to check and get data
      axios
        .get(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/contacts`,
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              Authorization: "Bearer " + getCookie("token"),
            },
          }
        )
        .then((response) => {
          setnewSocialMedia([]);

          if (response.data.isSuccess) {
            let stepStatus = response.data.data.stepStatus;
            let data = response.data.data;

            // check user is registered or not
            if (!stepStatus.isRegistered) {
              props.history.push({
                pathname: "/signup",
              });
            }
            // check the business steps are completed or not
            else if (stepStatus.isComplete) {
              props.history.push({
                pathname: "/business-dashboard",
              });
            }
            // check the business step number
            else if (stepStatus.regStep < 5) {
              props.history.push({
                pathname: `/register-business-step${stepStatus.regStep}`,
              });
            } else {
              if (JSON.parse(localStorage.getItem("step5-back-data"))) {
                // set data from local storage to states
                data = JSON.parse(localStorage.getItem("step5-back-data"));
              } else {
                // set data from api to states
                data = response.data.data;
              }

              setDataCome(true);
              setSocialCome(true);

              setBusinessAddId(data.baId);
              let p1 = "";
              let p2 = "";
              let p3 = "";
              let p4 = "";

              for (let index = 0; index < data.phones.length; index++) {
                const element = data.phones[index];

                if (element.type == "mobile") {
                  p4 = data.phones[index].number;
                } else if (element.type == "fax") {
                  p3 = data.phones[index].number;
                } else if (element.type == "phone" && p1 == "") {
                  p1 = data.phones[index].number;
                } else if (element.type == "phone" && p1 !== "") {
                  p2 = data.phones[index].number;
                }
              }
              setCompletePhone(data.phones);

              setData({
                phonee1: p1,
                phonee2: p2,
                phonee3: p3,
                phonee4: p4,
                phonee5: data.webDetail
                  ? data.webDetail.email == null
                    ? ""
                    : data.webDetail.email
                  : "",
                phonee6: data.webDetail
                  ? data.webDetail.webSite == null
                    ? ""
                    : data.webDetail.webSite
                  : "",
              });

              setnewSocialMedia(data.socials);

              for (let index = 0; index < data.socials.length; index++) {
                const element = data.socials[index];
                if (element.address != "") {
                  setActiveSocialName(element.title);
                }
              }
              if (activeSocialName == "") {
                setActiveSocialName(data.socials[0].title);
              }

              if (data.phonee1) {
                setPhoneApi((PhoneApi) => ({
                  ...PhoneApi,
                  phonee1: data.phonee1.replace(/\D/g, ""),
                }));
              }
              if (data.phonee2) {
                setPhoneApi((PhoneApi) => ({
                  ...PhoneApi,
                  phonee2: data.phonee2.replace(/\D/g, ""),
                }));
              }
              if (data.phonee3) {
                setPhoneApi((PhoneApi) => ({
                  ...PhoneApi,
                  phonee3: data.phonee3.replace(/\D/g, ""),
                }));
              }
              if (data.phonee4) {
                setPhoneApi((PhoneApi) => ({
                  ...PhoneApi,
                  phonee4: data.phonee4.replace(/\D/g, ""),
                }));
              }
            }
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // comment for come data from mina -- load step1 api
      // axios
      //   .get(domain + "/api/biz/register/load-step5", {
      //     headers: {
      //       ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
      //       LangId: 1,
      //       BizId: getCookie("BizId"),
      //       // BizId:"mX5/b1inEry1VgWGKk24BQ=="
      //     },
      //   })
      //   .then((response) => {
      //     setDataCome(true);
      //     if (response.data.msg == "done") {
      //       let p1 = "";
      //       let p2 = "";
      //       let p3 = "";
      //       let p4 = "";
      //       for (let index = 0; index < response.data.Phones.length; index++) {
      //         const element = response.data.Phones[index];
      //         if (element.Type == "mobile") {
      //           p4 = response.data.Phones[index].Number;
      //         } else if (element.Type == "fax") {
      //           p3 = response.data.Phones[index].Number;
      //         } else if (element.Type == "phone" && p1 == "") {
      //           p1 = response.data.Phones[index].Number;
      //         } else if (element.Type == "phone" && p1 !== "") {
      //           p2 = response.data.Phones[index].Number;
      //         }
      //       }
      //       setCompletePhone(response.data.Phones);
      //       setData({
      //         phonee1: p1,
      //         phonee2: p2,
      //         phonee3: p3,
      //         phonee4: p4,
      //         phonee5: response.data.WebDetail
      //           ? response.data.WebDetail.Email == null
      //             ? ""
      //             : response.data.WebDetail.Email
      //           : "",
      //         phonee6: response.data.WebDetail
      //           ? response.data.WebDetail.WebSite == null
      //             ? ""
      //             : response.data.WebDetail.WebSite
      //           : "",
      //       });

      //       setnewSocialMedia(response.data.Socials);
      //       for (let index = 0; index < response.data.Socials.length; index++) {
      //         const element = response.data.Socials[index];
      //         if (element.address != "") {
      //           // console.log(element.address);
      //           setActiveSocialName(element.address);
      //         }
      //       }
      //       if (activeSocialName == "") {
      //         setActiveSocialName(response.data.Socials[0].title);
      //       }
      //       // console.log("activeSocialName");
      //       // console.log(activeSocialName);

      //       if (data.phonee1) {
      //         setPhoneApi((PhoneApi) => ({
      //           ...PhoneApi,
      //           phonee1: data.phonee1.replace(/\D/g, ""),
      //         }));
      //       }
      //       if (data.phonee2) {
      //         setPhoneApi((PhoneApi) => ({
      //           ...PhoneApi,
      //           phonee2: data.phonee2.replace(/\D/g, ""),
      //         }));
      //       }
      //       if (data.phonee3) {
      //         setPhoneApi((PhoneApi) => ({
      //           ...PhoneApi,
      //           phonee3: data.phonee3.replace(/\D/g, ""),
      //         }));
      //       }
      //       if (data.phonee4) {
      //         setPhoneApi((PhoneApi) => ({
      //           ...PhoneApi,
      //           phonee4: data.phonee4.replace(/\D/g, ""),
      //         }));
      //       }
      //       // console.log(PhoneApi);
      //     }
      //   })
      //   .catch((error) => {
      //     // alert(error);
      //   });
      // comment for come data from mina -- load step1 api

      setRender(true);
    }
  }, []);

  const submitHandler = (event) => {
    event.preventDefault();

    if (
      !Object.keys(errors).length &&
      errorPhone1.length === 0 &&
      errorPhone2.length === 0 &&
      errorPhone3.length === 0 &&
      errorPhone4.length === 0
    ) {
      setDisable(true);

      let my_list = [];

      let x;
      for (let index = 0; index < newSocialMedia.length; index++) {
        const element = newSocialMedia[index];
        x = {
          // BizId: getCookie("BizId"),
          bsaId: element.bsaId,
          smId: element.smId,
          address: element.address,
          icon: element.icon,
          iconPath: element.iconPath,
          title: element.title,
        };
        my_list.push(x);
      }

      const aid = JSON.parse(localStorage.getItem("AId")); //set local

      if (data.phonee1 && data.phonee1.length == 16) {
        var x1 = data.phonee1.replace(/\D/g, "");
      } else {
        var x1 = data.phonee1;
      }
      if (data.phonee2 && data.phonee2.length == 16) {
        var x2 = data.phonee2.replace(/\D/g, "");
      } else {
        var x2 = data.phonee2;
      }
      if (data.phonee3 && data.phonee3.length == 16) {
        var x3 = data.phonee3.replace(/\D/g, "");
      } else {
        var x3 = data.phonee3;
      }
      if (data.phonee4 && data.phonee4.length == 16) {
        var x4 = data.phonee4.replace(/\D/g, "");
      } else {
        var x4 = data.phonee4;
      }
      if (data.phonee6.length == 1) {
        var x6 = data.phonee6;
      } else {
        var x6 = data.phonee6;
      }
      if (data.phonee5.length == 1) {
        var x5 = data.phonee5;
      } else {
        var x5 = data.phonee5;
      }

      let PhoneList = [];

      let ph;
      let count = 0;
      for (let index = 0; index < CompletePhone.length; index++) {
        // console.log("-----for");
        // console.log(CompletePhone);
        // console.log(CompletePhone[index]);

        const element = CompletePhone[index];
        switch (element.type) {
          case "phone":
            if (count == 0) {
              ph = {
                baId: element.baId,
                btId: element.btId,
                type: element.type,
                prefixCode: element.prefixCode,
                number_RSA: element.number_RSA,
                number: x1,
                phoneStd: element.phoneStd,
              };
            } else {
              ph = {
                baId: element.baId,
                btId: element.btId,
                type: element.type,
                prefixCode: element.prefixCode,
                number_RSA: element.number_RSA,
                number: x2,
                phoneStd: element.phoneStd,
              };
            }
            count = count + 1;
            break;
          case "fax":
            ph = {
              baId: element.baId,
              btId: element.btId,
              type: element.type,
              prefixCode: element.prefixCode,
              number_RSA: element.number_RSA,
              number: x3,
              phoneStd: element.phoneStd,
            };
            break;
          case "mobile":
            ph = {
              baId: element.baId,
              btId: element.btId,
              type: element.type,
              prefixCode: element.prefixCode,
              number_RSA: element.number_RSA,
              number: x4,
              phoneStd: element.phoneStd,
            };
            break;
        }
        PhoneList.push(ph);
      }

      // var tel = "phone:" + x1 + ";phone:" + x2 + ";fax:" + x3 + ";mobile:" + x4;

      // var countryy = JSON.parse(localStorage.getItem("regStep4")).valueCountry.PrefixCode;
      var countryy = JSON.parse(localStorage.getItem("PrefixCode"));

      const dataPost = {
        bId: getCookie("BizId"),
        baId: businessAddId,
        // baId: aid,
        phones: PhoneList,
        // CountryPerfix: countryy, //aidin dasht
        webSite: x6,
        email: x5,
        socials: my_list,
      };

      axios
        .post(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/contacts`,
          dataPost,
          {
            headers: header,
            // "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((response) => {
          setDisable(false);
          if (response.data.isSuccess) {
            // success
            localStorage.removeItem("step5-back-data"); // remove data of step5 saved by back button

            props.history.push({
              pathname: "/register-business-step6",
            });
          }
        })
        .catch((error) => {
          // alert(error);
        });
    } else {
      setTouched({
        phonee1: true,
        phonee2: true,
        phonee3: true,
        phonee4: true,
        phonee5: true,
        phonee6: true,
      });
    }
  };

  const backHandler = () => {
    if (data.phonee1 && data.phonee1.length == 16) {
      var x1 = data.phonee1.replace(/\D/g, "");
    } else {
      var x1 = data.phonee1;
    }
    if (data.phonee2 && data.phonee2.length == 16) {
      var x2 = data.phonee2.replace(/\D/g, "");
    } else {
      var x2 = data.phonee2;
    }
    if (data.phonee3 && data.phonee3.length == 16) {
      var x3 = data.phonee3.replace(/\D/g, "");
    } else {
      var x3 = data.phonee3;
    }
    if (data.phonee4 && data.phonee4.length == 16) {
      var x4 = data.phonee4.replace(/\D/g, "");
    } else {
      var x4 = data.phonee4;
    }
    if (data.phonee6.length == 1) {
      var x6 = data.phonee6;
    } else {
      var x6 = data.phonee6;
    }
    if (data.phonee5.length == 1) {
      var x5 = data.phonee5;
    } else {
      var x5 = data.phonee5;
    }

    let PhoneList = [];

    let ph;
    let count = 0;
    for (let index = 0; index < CompletePhone.length; index++) {
      const element = CompletePhone[index];

      switch (element.type) {
        case "phone":
          if (count == 0) {
            ph = {
              baId: element.baId,
              btId: element.btId,
              type: element.type,
              prefixCode: element.prefixCode,
              number_RSA: element.number_RSA,
              number: x1,
              phoneStd: element.phoneStd,
            };
          } else {
            ph = {
              baId: element.baId,
              btId: element.btId,
              type: element.type,
              prefixCode: element.prefixCode,
              number_RSA: element.number_RSA,
              number: x2,
              phoneStd: element.phoneStd,
            };
          }
          count = count + 1;
          break;
        case "fax":
          ph = {
            baId: element.baId,
            btId: element.btId,
            type: element.type,
            prefixCode: element.prefixCode,
            number_RSA: element.number_RSA,
            number: x3,
            phoneStd: element.phoneStd,
          };
          break;
        case "mobile":
          ph = {
            baId: element.baId,
            btId: element.btId,
            type: element.type,
            prefixCode: element.prefixCode,
            number_RSA: element.number_RSA,
            number: x4,
            phoneStd: element.phoneStd,
          };
          break;
      }
      PhoneList.push(ph);
    }

    const dataLocal = {
      baId: businessAddId,
      webDetail: {
        webSite: x6,
        email: x5,
      },
      phones: PhoneList,
      socials: newSocialMedia,
    };

    localStorage.setItem("step5-back-data", JSON.stringify(dataLocal)); //set step5 loocal storage

    props.history.push({
      pathname: "/register-business-step4",
    });
  };

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      {render ? (
        <>
          {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

          <RegisterBusiness />
          <div>
            <CacheProvider value={cacheRtl}>
              <ThemeProvider theme={theme}>
                <MDBRow className="mx-0">
                  <div className="col-12 col-md-8 register-business-padd">
                    <div className="register-steps-right">
                      <h1 className="rb-step4-tit1">
                        اطلاعات تماس کسب‌و‌کار را وارد کنید
                      </h1>
                      {dataCome ? (
                        <>
                          {((errors.phonee1 && touched.phonee1) ||
                            (errors.phonee2 && touched.phonee2) ||
                            (errors.phonee3 && touched.phonee3) ||
                            (errors.phonee4 && touched.phonee4) ||
                            (errors.phonee5 && touched.phonee5) ||
                            (errors.phonee6 && touched.phonee6)) &&
                            (errors.phonee6 ? (
                              <span className="input-error input-error-s5 centerr me-1 text-align-center text-align-md-right">
                                {errors.phonee6}
                              </span>
                            ) : (
                              <span className="input-error input-error-s5 centerr me-1 text-align-center text-align-md-right">
                                {errors.phonee5}
                              </span>
                            ))}

                          <div className="d-md-flex">
                            <div className="mb-3 ms-md-3">
                              <InputMask
                                formatChars={formatChar}
                                mask={phonestd}
                                // maskChar={null}
                                value={data.phonee1}
                                onChange={inputChangeHandler}
                              >
                                {(inputProps) => (
                                  <TextField
                                    dir="ltr"
                                    type="text"
                                    name="phonee1"
                                    onChange={inputChangeHandler}
                                    // value={data.phonee1}
                                    id="outlined-basic"
                                    label="شماره تماس"
                                    variant="outlined"
                                    className={
                                      "font-family-en label-field-more7 custom-text-field custom-text-field-contact mb-0 width20vw"
                                    }
                                    {...inputProps}
                                  />
                                )}
                              </InputMask>
                              {errorPhone1 && (
                                <span className="input-error-auto me-1">
                                  {errorPhone1}
                                </span>
                              )}
                              {/* <TextField
                        dir="ltr"
                        type="text"
                        name="phonee1"
                        value={data.phonee1}
                        onChange={inputChangeHandler}
                        id="outlined-basic"
                        label="شماره تماس"
                        variant="outlined"
                        className={
                          "font-family-en  label-field-more7 custom-text-field custom-text-field-contact mb-0 width20vw"
                        }
                      /> */}
                            </div>
                            <div className="mb-3">
                              <InputMask
                                formatChars={formatChar}
                                mask={phonestd}
                                // maskChar={null}
                                value={data.phonee2}
                                onChange={inputChangeHandler}
                              >
                                {(inputProps) => (
                                  <TextField
                                    dir="ltr"
                                    type="text"
                                    name="phonee2"
                                    onChange={inputChangeHandler}
                                    // value={data.phonee2}
                                    id="outlined-basic"
                                    label="شماره تماس"
                                    variant="outlined"
                                    className={
                                      "font-family-en label-field-more7 custom-text-field custom-text-field-contact mb-0 width20vw"
                                    }
                                    {...inputProps}
                                  />
                                )}
                              </InputMask>
                              {errorPhone2 && (
                                <span className="input-error-auto me-1">
                                  {errorPhone2}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="d-md-flex">
                            <div className="mb-3 ms-md-3">
                              <InputMask
                                mask={phonestd}
                                formatChars={formatChar}
                                // maskChar={null}
                                value={data.phonee3}
                                onChange={inputChangeHandler}
                              >
                                {(inputProps) => (
                                  <TextField
                                    dir="ltr"
                                    type="text"
                                    name="phonee3"
                                    onChange={inputChangeHandler}
                                    // value={data.phonee3}
                                    id="outlined-basic"
                                    label="شماره فکس"
                                    variant="outlined"
                                    className={
                                      "font-family-en label-field-more7 custom-text-field custom-text-field-contact mb-0 width20vw"
                                    }
                                    {...inputProps}
                                  />
                                )}
                              </InputMask>
                              {errorPhone3 && (
                                <span className="input-error-auto me-1">
                                  {errorPhone3}
                                </span>
                              )}
                            </div>

                            <div className="mb-3">
                              <InputMask
                                mask={phonestd}
                                formatChars={formatChar}
                                // maskChar={null}
                                value={data.phonee4}
                                onChange={inputChangeHandler}
                              >
                                {(inputProps) => (
                                  <TextField
                                    dir="ltr"
                                    type="text"
                                    name="phonee4"
                                    onChange={inputChangeHandler}
                                    // value={data.phonee4}
                                    id="outlined-basic"
                                    label="شماره موبایل"
                                    variant="outlined"
                                    className={
                                      "font-family-en label-field-more7 custom-text-field custom-text-field-contact mb-0 width20vw"
                                    }
                                    {...inputProps}
                                  />
                                )}
                              </InputMask>
                              {errorPhone4 && (
                                <span className="input-error-auto me-1">
                                  {errorPhone4}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="mb-3">
                            <TextField
                              dir="ltr"
                              type="text"
                              name="phonee6"
                              value={data.phonee6}
                              onChange={inputChangeHandler}
                              id="outlined-basic"
                              label="آدرس وبسایت"
                              variant="outlined"
                              className={
                                "label-field-more7 custom-text-field custom-text-field-contact mb-0 font-family-en"
                              }
                            />
                          </div>
                          <div className="mb-3">
                            <TextField
                              dir="ltr"
                              type="text"
                              name="phonee5"
                              value={data.phonee5}
                              onChange={inputChangeHandler}
                              id="outlined-basic"
                              label="ایمیل"
                              variant="outlined"
                              className={
                                "label-field-more7 custom-text-field custom-text-field-contact mb-0 font-family-en"
                              }
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="d-md-flex width-42vw width-sm-100">
                            <Skeleton
                              className="profile-Skeleton ms-3"
                              variant="rectangular"
                              height={30}
                              animation="wave"
                            />
                            <Skeleton
                              className="profile-Skeleton mt-3 mt-md-0 "
                              variant="rectangular"
                              height={30}
                              animation="wave"
                            />
                          </div>
                          <div className="d-md-flex width-42vw width-sm-100">
                            <Skeleton
                              className="profile-Skeleton mt-3 ms-3"
                              variant="rectangular"
                              height={30}
                              animation="wave"
                            />
                            <Skeleton
                              className="profile-Skeleton mt-3 "
                              variant="rectangular"
                              height={30}
                              animation="wave"
                            />
                          </div>
                          <Skeleton
                            className="profile-Skeleton mt-3"
                            variant="rectangular"
                            height={30}
                            animation="wave"
                          />
                        </>
                      )}
                      <div className="rb-step4-icons-div mt-4">
                        {dataCome && socialCome
                          ? activeSocialName != "" && (
                              <>
                                {console.log("")}
                                {newSocialMedia.map((item) => (
                                  <div
                                    key={item.bsaId}
                                    style={
                                      item.title == activeSocialName &&
                                      item.title == "Youtube"
                                        ? {
                                            backgroundColor: "rgb(247, 0, 0)",
                                          }
                                        : item.title == activeSocialName &&
                                          item.title == "Telegram"
                                        ? {
                                            backgroundColor:
                                              "rgb(36, 158, 218)",
                                          }
                                        : item.title == activeSocialName &&
                                          item.title == "Twitter"
                                        ? {
                                            backgroundColor:
                                              "rgb(28, 150, 232)",
                                          }
                                        : item.title == activeSocialName &&
                                          item.title == "Instagram"
                                        ? {
                                            background:
                                              "linear-gradient(115deg, #f9ce34, #ee2a7b, #6228d7)",
                                          }
                                        : item.title == activeSocialName &&
                                          item.title == "Linkedin"
                                        ? {
                                            backgroundColor: "rgb(2, 112, 173)",
                                          }
                                        : item.title == activeSocialName &&
                                          item.title == "facebook"
                                        ? {
                                            backgroundColor: "rgb(56, 82, 154)",
                                          }
                                        : item.bsaId && item.title == "Youtube"
                                        ? {
                                            backgroundColor:
                                              "rgba(247, 0, 0, 0.7)",
                                          }
                                        : item.bsaId && item.title == "Telegram"
                                        ? {
                                            backgroundColor:
                                              "rgba(36, 158, 218, 0.7)",
                                          }
                                        : item.bsaId && item.title == "Twitter"
                                        ? {
                                            backgroundColor:
                                              "rgba(28, 150, 232, 0.7)",
                                          }
                                        : item.bsaId &&
                                          item.title == "Instagram"
                                        ? {
                                            background:
                                              "linear-gradient(115deg, #f9ce34, #ee2a7b, #6228d7)",
                                            opacity: "0.7",
                                          }
                                        : item.bsaId && item.title == "Linkedin"
                                        ? {
                                            backgroundColor:
                                              "rgba(2, 112, 173, 0.7)",
                                          }
                                        : item.bsaId && item.title == "facebook"
                                        ? {
                                            backgroundColor:
                                              "rgba(56, 82, 154, 0.7)",
                                          }
                                        : {}
                                    }
                                    // item.bsaId
                                    // ? item.title == activeSocialName
                                    //   ? "rb-step4-icons rb-s4-active bg-green"
                                    //   : "rb-step4-icons bg-green"
                                    // : item.title == activeSocialName
                                    // ? "rb-step4-icons rb-s4-active"
                                    // : "rb-step4-icons"
                                    className={`rb-step4-icons ${
                                      item.title == activeSocialName
                                        ? "rb-s4-active"
                                        : ""
                                    }`}
                                    id={item.title}
                                    onMouseOver={() =>
                                      socialHandler(item.title)
                                    }
                                  >
                                    <img
                                      className={`rb-step4-icon ${
                                        (item.bsaId ||
                                          item.title == activeSocialName) &&
                                        "rb-s4-i-w"
                                      }`}
                                      src={item.icon}
                                      alt=""
                                    />
                                  </div>
                                ))}
                              </>
                            )
                          : newSocialMedia.map((item) => (
                              <div className="Skeleton-s5 mt-1 p-0">
                                <Skeleton
                                  className="bg-skeleton"
                                  variant="circular"
                                  width={35}
                                  height={35}
                                />
                              </div>
                            ))}
                      </div>

                      {dataCome && socialCome ? (
                        <form action="">
                          {newSocialMedia.map((item) => (
                            <div
                              key={item.smId}
                              className={
                                item.title == activeSocialName
                                  ? "d-flex width-sm-100"
                                  : "d-none"
                              }
                            >
                              <div className="material material2 mb-md-3 ">
                                <input
                                  dir="ltr"
                                  value={item.address}
                                  onChange={(e) =>
                                    socialMHandeler2(e, item.smId)
                                  }
                                  type="submit"
                                  className="input_custom input_custom2 font-family-en"
                                  type="text"
                                  // required
                                  placeholder={item.title}
                                />
                                <span className="borda borda2"></span>
                              </div>
                              <MDBBtn
                                onClick={(e) => alertHandeler(e)}
                                className="rb-s5-zakhire"
                                color="success"
                                name={item.title}
                              >
                                ذخیره
                              </MDBBtn>
                            </div>
                          ))}
                        </form>
                      ) : (
                        <Skeleton
                          className="profile-Skeleton mt-3"
                          variant="rectangular"
                          height={30}
                          animation="wave"
                        />
                      )}

                      <div className="mt-1">
                        {dataCome ? (
                          <div className="rb-steps-btns">
                            <Link
                              // to="/register-business-step4"
                              className="rb-steps-btn1 hov-shadow"
                              onClick={backHandler}
                            >
                              مرحله قبلی
                            </Link>
                            <MDBBtn
                              disabled={disable}
                              onClick={submitHandler}
                              className="rb-steps-btn2 hov-shadow"
                            >
                              مرحله بعدی
                            </MDBBtn>
                          </div>
                        ) : (
                          <div className="rb-steps-btns">
                            <Skeleton
                              className="rb-steps-btn2 h-Skeleton-39"
                              variant="rectangular"
                              width={123}
                              height={39}
                              animation="wave"
                            />
                            <Skeleton
                              className="rb-steps-btn2 h-Skeleton-39"
                              variant="rectangular"
                              width={123}
                              height={39}
                              animation="wave"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-4 px-0 text-center d-md-block d-none">
                    <img
                      className="register-business-img"
                      src={imgg}
                      alt="register business"
                    />
                  </div>
                </MDBRow>
              </ThemeProvider>
            </CacheProvider>
          </div>
          <AlertSuccess
            showAlert={showAlert}
            text={"اطلاعات شما با موفقیت ثبت شد ."}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default RegisterBusinessStep4;
